"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { ErrorView } from "@/components/error-view";
import { Button } from "@/components/ui/button";

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations();

  return (
    <ErrorView
      code="500"
      title={t("errors.500.title")}
      description={t("errors.500.description")}
    >
      <Button onClick={reset}>{t("errors.retry")}</Button>
      <Button asChild variant="outline">
        <Link href="/">{t("errors.home")}</Link>
      </Button>
    </ErrorView>
  );
}
